import { useModalManager } from "@/composables/useModalManager";
import { usePayments } from "@/composables/usePayments";
import { useSocialAuthResolver } from "@/composables/useSocialAuthResolver";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import { createRouter, createWebHistory, useRouter } from "vue-router";
import { routes } from "./routes";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 });
    });
  }
});

router.beforeEach((to) => {
  const loader = document.getElementById('initial-loader');
  if (to.fullPath === "/landing" || to.fullPath.startsWith("/landing/")) {
    loader && (loader.style.display = "none");
  } else {
    loader && (loader.style.display = "flex");
  }

  if (to.fullPath === "/vexalabs" ) {
    loader && (loader.style.display = "none");
    return ;
  }

  const maintenanceOn = (import.meta.env.VITE_MAINTENANCE_MODE || "off") == "on";

  const authStore = useAuthenticationStore();
  const { getRedirectUrl, removeRedirectUrl } = useModalManager();
  const { checkForAuthCallback } = useSocialAuthResolver();
  const { checkPaymentStatus } = usePayments();
  const redirect = getRedirectUrl();
  const router = useRouter();

  return new Promise((resolve) => {
    const evaluate = async () => {
      if (!authStore.loaded && !to.fullPath.includes("landing")) {
        await authStore.refreshUser();
        resolve(evaluate());
        return;
      }

      if (maintenanceOn && to.name.toString().toLocaleLowerCase() != "maintenance") {
        resolve({ name: "maintenance" });
        return;
      }

      if (to.name == "register-upsell" && authStore.user && authStore.user.has_access) {
        resolve({ name: "home" });
        return;
      }

      if (redirect) {
        removeRedirectUrl();
        const resolved = router.resolve(redirect);

        await router.push({
          path: resolved.path,
          query: to.query
        });
        return;
      }


      //Check social auth callback and action
      await checkForAuthCallback(to);
      //Check payment status
      await checkPaymentStatus(to);

      resolve();
    };

    return evaluate();
  });
});

export default router;
